export default () => ({
  root: {
    display: 'flex',
    flex: 'row nowrap',
    justifyContent: 'space-between',
    marginBottom: '1rem'
  }
});
